<template>
  <v-dialog width="300" v-model="isFolderCreatedDialogOpen" persistent>
    <v-card>
      <v-card-text>
        Processo criada com sucesso!
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="closeDialog">Voltar a lista</v-btn>
        <v-btn flat color="blue" @click="openFolder">Abrir</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FolderCreatedDialog',
  props: {
    isFolderCreatedDialogOpen: {
      default: false,
      type: Boolean,
    },
    folderCreated: {
      default: {},
      type: Object,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('toggleFolderCreatedDialog', { showDialog: false });
    },
    openFolder() {
      const url = this.$router.resolve({
        name: 'ShowFolder',
        params: { id: this.folderCreated.id },
      });
      window.open(url.href, '_blank');
      this.$emit('toggleFolderCreatedDialog', { showDialog: false });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/folder/new/FolderCreatedDialog.vue